import { Component, Input, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController, ModalController, LoadingController } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import { CuentasPorCobrarProvider } from '../../providers/cuentas-por-cobrar/cuentas-por-cobrar'
import { CajaProvider } from '../../providers/caja/caja'
import { Storage } from '@ionic/storage'
import { File } from '@ionic-native/file';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { UtilsProvider } from '../../providers/utils/utils'
import { NUBE_AWS } from '../../config/url.servicio';
import { AuthService } from '../../providers/auth-service';
import { ParametrosGeneralesRedux } from '../../providers/redux/parametrosgenerales/parametrosgenerales';
import { Base64 } from 'js-base64';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { valueDisplay } from '../../models/valueDisplay.model';
import { DianProvider } from '../../providers/dian/dian';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { State } from '../../store/app.reducer'
import { Store } from '@ngrx/store';
import * as fromClienteSelect from '../cliente-select/state/cliente-select/cliente-select-accions'
import { ClienteSelectPage } from '../cliente-select/cliente-select';
import { WhatsappPage } from '../whatsapp/whatsapp';
import { UtilsRedux } from '../../providers/redux/utils/utils';
import { ClienteSelectRedux } from '../../providers/redux/clienteselect/clienteselect';
import { CuentasPorCobrarCreditosVisualizarPage } from '../cuentas-por-cobrar-creditos-visualizar/cuentas-por-cobrar-creditos-visualizar';
import { CuentasPorCobrarCreditosVisualizarPlanDePagosPage } from '../cuentas-por-cobrar-creditos-visualizar-plan-de-pagos/cuentas-por-cobrar-creditos-visualizar-plan-de-pagos';

@IonicPage()
@Component({
  selector: 'page-cuentas-por-cobrar-creditos',
  templateUrl: 'cuentas-por-cobrar-creditos.html',
  providers: [ ClienteSelectRedux, UtilsRedux,File,InAppBrowser, AuthService, ParametrosGeneralesRedux, DianProvider ]
})

export class CuentasPorCobrarCreditosPage implements OnInit {

  @Input() arrayWhereLocal: any = []
  public clientesId:any
  recibo:string = "";
  pagoTotal:boolean=false
  datosCredito = []
  datosCreditoTemporal = []
  clienteId = []
  valoresTotales = []
  valorPagado:number = 0
  valorPendiente:number = 0
  data: any[][]
  companiasId;
  bluetooth:boolean = false
  fechaPagoReal:Date
  detalle:string = ''
  comprobantePago:string = ''
  listaClientes = [];
  valoresCliente: string = 'Buscar Cliente';
  isLoading: boolean = false;
  public isButtonDisabledCliente: boolean = false;
  public isButtonDisabledPago: boolean = false;
  interesCreditos:any[] = []
  planDePagos:any[]=[]
  datacliente:any[] = []
  paginaActual: number = 1;
  buscarTexto: string = '';
  item: string = '';
  mostrarGrid: boolean= true;
  cliente: string = ''
  totalDeuda: number = 0
  planDePagosCuentaPorCobrar:any[]=[]
  calcularValoresCuentaPorCobrar:any[]=[]
  cargando: boolean = true;
  progreso: number = 0;
  resultados: any[] = [];
  factura:string = ''
  itemPlanDePagos: any = { totalPagoActual: 0 };
  mostrarPlanDePagos: boolean = false;
  selectedPlan:any =  0
  totalSeleccionado: number = 0;
  storageCreditos:any
  datosCreditos:any
  isHovering = false;
  @Input() loadDataOnInit: boolean = false;
  private timeoutId: any;
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public buscarCuentasPorCobrarProvider:CuentasPorCobrarProvider,
              public servicio:CajaProvider,
              private storage: Storage,
              public alertControllers: AlertController,
              public file: File,private iab: InAppBrowser,
              public utils: UtilsProvider,
              public auth: AuthService,
              public utilsParametrosGeneralesRedux: ParametrosGeneralesRedux,
              public dian: DianProvider,
              private store:Store<State>,
              public modalControllers: ModalController
              ,public utilsRedux: UtilsRedux,
              public clienteSelectRedux: ClienteSelectRedux,
              public loadingCtrl: LoadingController) {

  }


  ngOnInit() {
    if (this.loadDataOnInit) {
      this.valoresIniciales();
    }
  }

cambiarPagoTotal(){
  this.pagoTotal = !this.pagoTotal
}

cerrarSession() {
  this.auth.logout()
  this.navCtrl.setRoot('LoginPage');
}

 async buscarCuentaPorCobrar(numeroFactura:any){
    let companiasId = await this.storage.get('companiasId')
    let jsonFiltro = []
    let clienteId
    if (this.clienteId && this.clienteId[0] && this.clienteId[0]['value']) {
      clienteId = this.clienteId[0]['value']
    }else{
      return false
    }
    jsonFiltro.push(
      {companiasId:companiasId,clientesId:clienteId,numeroFactura:numeroFactura}
    )
    try {
      const resultadoCuenta = await this.servicio.buscarCuentaPorCobrarAsync(jsonFiltro)
      const datosDevueltos = resultadoCuenta.json();
      let resultCreditosPorCliente = datosDevueltos.data[0]

      let creditos = resultCreditosPorCliente.map((item)=> {
        return {
          cuentasPorCobrarId: item.cuentasPorCobrarId
        }
      })
      const loader = this.loadingCtrl.create({
        content: 'Procesando créditos... 0%'
      });
      loader.present();

      const total = creditos.length;
      this.totalDeuda = 0
      const cuentasSumadas = new Set();
      for (let i = 0; i < total; i++) {
        const credito = creditos[i];
        const responseCalcularCreditos = await this.servicio.calcularValoresCuentaPorCobrarAsync(
          companiasId,credito.cuentasPorCobrarId);

        const resultadoCalcularCreditos = responseCalcularCreditos.json();
        this.resultados = this.resultados.concat(resultadoCalcularCreditos);

        const nuevoArray = this.resultados.map(item => {
          const cuentasPorCobrarId = item && item.data && item.data[1] && item.data[1][0]
          ? item.data[1][0].cuentasPorCobrarId
          : null;

        const totalDeudaItem = item && item.data && item.data[1] && item.data[1][0] && item.data[1][0].totalDeudaFecha
          ? item.data[1][0].totalDeudaFecha
          : 0;

        // Solo sumamos si el cuentasPorCobrarId no ha sido sumado antes
        if (cuentasPorCobrarId && !cuentasSumadas.has(cuentasPorCobrarId)) {
            cuentasSumadas.add(cuentasPorCobrarId);
            this.totalDeuda += totalDeudaItem;
        }
          return {
              ...item.data
          };
      });
        this.datosCreditoTemporal = nuevoArray
        this.progreso = Math.floor(((i + 1) / total) * 100);
        loader.setContent(`Procesando créditos... ${this.progreso}%`);
      }

      loader.dismiss();
      this.datosCredito = this.flattenArray(this.datosCreditoTemporal.map(item => item["1"]));

  this.datosCredito.forEach(credito => {
  // Iterar sobre todos los elementos en datosCreditoTemporal["0"]
  for (let key in this.datosCreditoTemporal) {
    if (this.datosCreditoTemporal.hasOwnProperty(key)) {
      const cuotas = this.datosCreditoTemporal[key]["0"];
      const cuota = cuotas.find(c => c.cuentasPorCobrarId == parseInt(credito.cuentasPorCobrarId, 10));
      if (cuota) {
        credito.valorCuota = cuota.valorCuota;
        break; // Salir del bucle una vez que se encuentra la cuota correspondiente
      }
    }
  }
});

console.log(this.datosCredito);
      console.log('Array 1:', this.datosCredito)
      this.cargando = false;
      this.buscarTexto = ""
      this.mostrarGrid = false
    } catch (error) {
      this.cargando = false;
      this.mostrarGrid = true
      this.cliente = ''
      this.factura = ''
      this.resultados = []
      this.datosCreditoTemporal = []
      this.datosCredito = []
    }
 }

 flattenArray(arr: any[][]): any[] {
  return arr.reduce((acc, curr) => acc.concat(curr), []);
}

limpiar(){
  this.clienteId = []
  this.valoresTotales = []
  this.datosCredito = []
  this.calcularValoresCuentaPorCobrar = []
  this.valorPagado = 0
  this.valorPendiente = 0
  this.buscarCuentaPorCobrar('')
  this.limpiarCampos()
  this.valoresCliente = 'Buscar Cliente : '
  this.planDePagos = []
  this.clienteId = []
  this.buscarTexto = ""
  this.cliente = ''
  this.factura = ''
  this.resultados = []
  this.datosCreditoTemporal = []
  this.datosCredito = []
  this.totalSeleccionado = 0
}

mostrarMensajeAdvertencia(mensaje,titulo) {
  let alert = this.alertControllers.create({
    title: titulo,
    subTitle: mensaje,
    buttons: ['Cerrar']
  });
  alert.present();
}

printD(codigo:any) {
  this.storage.get('companiasId').then((companiasId)=>{
    this.servicio.imprimirComandaBlue(codigo,companiasId)

   .subscribe((data)=>{



   let items = JSON.parse(data['_body']).data
   this.imprimirArchivoBlue(items[0])
   })
})
}

imprimirArchivoBlue(datos) {
  let datanew = datos
  let recibo = ''

  for (let index:any = 0; index < datanew.length; index++) {
    recibo +=  '   ' + datanew[index]['reciboCaja'] + '\n'
  }

  let encodedString = Base64.encode(recibo);
  window.open(`sartprintbluetooth://print/${encodedString}`, '_self');

}

imprimirCuentaPorCobrar(codigo:any){
    this.storage.get('companiasId').then((val) => {

    if(1===1) {

    }

    this.servicio.buscarFacturaCuentaPorCobrar(codigo,val)
    .subscribe((data)=>{
      let res = NUBE_AWS ? JSON.parse(data['_body']).data : data
      let response = NUBE_AWS ? res[0] : res.json()
      this.reemprimirRecibo(response)
    },
     error=>{
       console.log(error)
     })
    })
}

reemprimirRecibo(mensaje) {
  let recibo = ''
  mensaje = mensaje == undefined ? [] : mensaje
for (let index:any = 0; index < mensaje.length; index++) {
  recibo += mensaje[index]['reciboCaja'] + '\n'
}

  this.servicio.imprimirRecibo(recibo).subscribe(
      res => {

      },
      err => {

              let alert = this.alertControllers.create({
                  title: '',
                  subTitle: recibo,
                  buttons: ['Cerrar']
              });
              alert.present();

          })
}

mensaje(){
  this.utils.mensajeMuestro('Se puede pagar el total de la deuda al seleccionar el boton "Pagar valor total"','Mensaje general','warning')
}


devolverTel(tel: any) {
  let cadenaOriginal = tel.reciboCaja;
  let valorEliminar = "Tel:";
if (cadenaOriginal.includes(valorEliminar)) {
  let cadenaSinValor = cadenaOriginal.replace(valorEliminar, '').trim();
  let numeros = cadenaSinValor;
  return numeros
} else {
  return ''
}
}

getMultiple(keys: string[]) {
  const promises = [];

  keys.forEach( key => promises.push(this.storage.get(key)) );

  return Promise.all(promises).then( values => {
    const result = {};

    values.map( (value, index) => {
      result[keys[index]] = value;
    });

    return result;
  });
}
public requestAutocompleteItems = (text: string): Observable<Response> => {
  return this.servicio.buscarClientesPorCompania(text, this.companiasId)
};

enviarWhatsApp(item) {
      let recibo = ''
      let data = []
      let numero =  item.numeroTelefono
      const numerovalorFactura = item.valorFactura.toLocaleString('en');
      const numerovalorPagado = item.valorPagado.toLocaleString('en');
      const numerovalorPendiente = item.valorPendiente.toLocaleString('en');
      recibo +=  '   Asi vamos...: ' + '\n'
      recibo +=  '   Fecha: ' + item.fecha + '\n'
      recibo +=  '   Nombre completo: ' + item.nombreCompleto + '\n'
      recibo +=  '   Factura: ' + item.numeroFactura + '\n'
      recibo +=  '   Valor factura: ' + numerovalorFactura + '\n'
      recibo +=  '   Pagado: ' + numerovalorPagado + '\n'
      recibo +=  '   Pendiente: ' + numerovalorPendiente + '\n'

        recibo +=  '  ---------------------------------' + '\n'
        data.push(recibo)

        const url = `https://api.whatsapp.com/send?phone=${numero}&text=${encodeURIComponent(
                  recibo
        )}`;
       window.open(url, '_system');
}

getBase64ImageFromURL(url) {
  return new Promise((resolve, reject) => {
    var img = new Image();
    img.setAttribute("crossOrigin", "anonymous");

    img.onload = () => {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      var dataURL = canvas.toDataURL("image/png");

      resolve(dataURL);
    };

    img.onerror = error => {
      reject(error);
    };

    img.src = url;
  });
}


limpiarCampos() {
  this.fechaPagoReal = new Date(),
  this.detalle = ''
  this.comprobantePago = ''
}

async buscarValoresCliente() {
  let responseCompania = await this.dian.devolverCompania()
  let companiaId = this.companiasId == undefined ? responseCompania : this.companiasId
  this.servicio.buscarClientesPorCompaniaAll(companiaId)
  .subscribe(async (data: any)=>{
    this.isButtonDisabledCliente = true;
    let clientes: any = data;
    this.listaClientes = clientes;
    this.datacliente = this.listaClientes
  },(error)=> {console.log(error)})
}

buscarClienteSelect() {
  this.buscarClientes()
 }
 async buscarClientes() {
  let responseCompania = await this.dian.devolverCompania()
    let companiaId = this.companiasId == undefined ? responseCompania : this.companiasId
    if(companiaId == undefined) {
      this.utils.mensajeMuestro('Debe salir y volver a entrar a la aplicación para generar la nota crédito..','Advertencia!','advertencia')
      return
    }
  this.servicio.buscarClientesPorCompaniaAll(companiaId)
  .subscribe(async (data: any)=>{
    this.isButtonDisabledCliente = true;
    let clientes: any = data;
    this.listaClientes = clientes;

    let modal = this.modalControllers.create(ClienteSelectPage, { data: this.listaClientes }
      )
    modal.present();

    modal.onDidDismiss(data => {
      if (data) {
        this.clienteId.push({value:data.value, display:data.display})
        let cliente: valueDisplay[] = [{
          value:data.value,
          display:data.display
        }]
        this.clienteId = cliente
        const actionClienteCaja = new fromClienteSelect.CargarValueDisplaySuccessActions(cliente);
        this.store.dispatch(actionClienteCaja);
        this.valoresCliente = 'Buscar Cliente : ' + data.display;
        this.isButtonDisabledCliente = false;
      } else {
        this.isButtonDisabledCliente = false;
      }
    })
  })
}


addLeadingZero(valor: number): string {
  return valor < 10 ? '0' + valor : valor.toString();
}

buscar(event) {
  this.mostrarGrid = true
  this.buscarTexto = event.value;
  this.cliente = ''
  this.factura = ''
  this.calcularValoresCuentaPorCobrar = []
  this.planDePagos = []
  this.datosCredito = []
  this.valoresTotales = []
  this.resultados = []
  this.datosCreditoTemporal = []
  this.totalSeleccionado = 0
}

async ionViewDidLoad() {
  this.valoresIniciales()
}

async valoresIniciales() {
  this.paginaActual = 1;
  this.buscarValoresCliente()
  this.buscarValoresSelectStore();
  try {
    this.storageCreditos = await this.getDatosCreditos();

    if (this.storageCreditos) {
      console.log('Datos obtenidos:', this.storageCreditos);
    } else {
      console.log('No hay datos almacenados');
    }
  } catch (error) {
    console.error('Error obteniendo datos:', error);
  }
}

getDatosCreditos(): Promise<any> {
  return new Promise((resolve, reject) => {
    try {
      const datosCreditos = localStorage.getItem('datosCreditos');
      if (datosCreditos) {
        resolve(JSON.parse(datosCreditos)); // Resolver si hay datos
      } else {
        resolve(null); // Resolver como null si no hay datos
      }
    } catch (error) {
      reject(error); // Rechazar en caso de error
    }
  });
}

async buscarValoresSelectStore() {
}
devolverValor(item) {
  this.mostrarGrid = true
  this.item = item;
  this.clienteId[0] = this.item
  this.cliente = this.clienteId[0].display
  this.buscarTexto = ""
  this.datosCredito = []
  this.buscarCuentaPorCobrar("")
}

formatFecha(fecha: string) {
  const date = new Date(fecha);
  return date.toISOString().split('T')[0];
}

async togglePlanDePagos(item:any) {
  if (item.mostrarPlanDePagos) {
    this.factura = item.cuentasPorCobrarId
    let companiasId = await this.storage.get('companiasId')
    const responseCalcularCreditos = await this.servicio.calcularValoresCuentaPorCobrarAsync(
      companiasId,item.cuentasPorCobrarId);
    const resultadoCalcularCreditos = responseCalcularCreditos.json();
    let modal = this.modalControllers.create(CuentasPorCobrarCreditosVisualizarPage,{data:resultadoCalcularCreditos.data[0]},
      {
       cssClass: 'fullscreen-modal',
       enableBackdropDismiss: true
     }
    )
    modal.present();
    modal.onDidDismiss(data => {
     if (data !== null && data !== undefined ) {
        let valores = data.item
        this.actualizarDatosCredito(valores)
     }
    })
  } else {
    this.actualizarTotalSeleccionado()
    item.selectedPlan = null; // Resetea el plan de pagos seleccionado si se desactiva el checkbox
    this.factura = ""
  }
}

actualizarDatosCredito(itemActualizado: any) {
  const index = this.datosCredito.findIndex(item => item.cuentasPorCobrarId == itemActualizado.cuentasPorCobrarId);
  if (index !== -1) {
    this.datosCredito[index].totalPagoActual = itemActualizado.totalPagoCuota;
    //this.datosCredito[index].valorCuota = itemActualizado.valorCuota
    this.datosCredito[index].mostrarPlanDePagos = true;
    this.actualizarTotalSeleccionado()
 }
}

actualizarTotalSeleccionado() {
  this.totalSeleccionado = 0
  this.datosCredito.forEach(item => {
    if(item.mostrarPlanDePagos) {
        this.totalSeleccionado += item.totalPagoActual;
      }
  });
}
  // Función para formatear el valor con separadores de miles
  formatCurrency(value: number): string {
    return value ? value.toLocaleString('es-ES', { minimumFractionDigits: 2 }) : '';
  }


pagarCreditoTotal() {
  let totalSeleccionado = this.formatCurrency(this.totalSeleccionado)
  this.utils.mensajeConfirmacionDos('Pagar crédito',`¿Está Seguro de pagar este valor ${totalSeleccionado}  ?`,'question','Si','No')
  .then(async (pagarCredito: boolean) => {
   if (pagarCredito) {
    const itemsSeleccionados = this.datosCredito.filter(item => item.mostrarPlanDePagos);
    if (itemsSeleccionados.length > 0) {
      this.pagarCreditoNuevo(itemsSeleccionados)
    } else {
      this.utils.mensajeMuestro('Pagar crédito','Selecciona al menos un crédito para pagar.','warning')
      return
    }
   }
   else {
     this.utils.mensajeMuestro('Pagar crédito','No se genero ningun pago','warning')
   }
 })
}

async pagarCreditoNuevo(item:any){
  this.getMultiple(['usuariosId','companiasId'])
  .then( async (res) => {
    let usuariosId =res['usuariosId']
    let companiasId =res['companiasId']
    let clienteId

    if (this.clienteId && this.clienteId[0] && this.clienteId[0]['value']) {
     clienteId = this.clienteId[0]['value']
    }else{
      this.utils.mensajeMuestro('Debe de seleccionar un cliente','Advertencia','warning')
      return false
    }
      let valorPendienteIndividual = item.totalPagoActual
      let comprobantePago = this.comprobantePago
      let fechaPagoReal = this.fechaPagoReal

      let elPago = []
      for(let i=0;i<item.length;i++){

        let totalPagado = item[i].totalPagoActual
        let cuentasPorCobrarId = item[i].cuentasPorCobrarId

        elPago.push({usuariosId:usuariosId,
          companiasId:companiasId,
          clientesId:clienteId,
          totalPagado:totalPagado,
          cuentasPorCobrarId:cuentasPorCobrarId,
          fechaPagoReal:this.fechaPagoReal,
          detalle:this.detalle,
          comprobantePago:this.comprobantePago,
          manejaIntereses:'S'
         })
      }
      this.servicio.almacenarPagoCuentaPorCobrar(elPago)
        .subscribe(async (data)=>{
          let res = NUBE_AWS ? JSON.parse(data['_body']).data : JSON.parse(data['_body'])
          let datosCreditos = localStorage.getItem('datosCreditos')
          let comprobanteWhatSapp = false
          let datosCredito = JSON.parse(datosCreditos)
          if(datosCredito && datosCredito["Enviar pago por Whatsaap"]) {
            comprobanteWhatSapp = datosCredito["Enviar pago por Whatsaap"].seleccion === 'S' ? true : false
          }

          if(comprobanteWhatSapp) {
            this.utils.mensajeConfirmacionDos('WS','¿Desea enviar el comprobante por WhatSapp?','question','Si','No')
               .then((ws: boolean) => {
                  if (ws) {
                   let numero = ''
                  if(res[0] != undefined && res[0][11] != undefined) {
                    numero = this.devolverTel(res[0][11])
                  }

                  var numerovalorPendienteIndividual = Number(valorPendienteIndividual)
                  item.valorPagado = item.valorPagado + numerovalorPendienteIndividual
                  item.valorPendiente = item.valorPendiente - numerovalorPendienteIndividual
                  item.comprobantePago = comprobantePago
                  item.fechaPagoReal = fechaPagoReal
                  let dataImprimir = JSON.stringify(res[0])
                  let modal = this.modalControllers.create(WhatsappPage, { dataImprimir: dataImprimir, numeroTelefono: numero, espacios: false }
                    )
                  modal.present();

                  modal.onDidDismiss(data => {
                  if (data) {
                  }
                  if(this.bluetooth) {
                  this.imprimirArchivoBlue(res[0])
                  }
                })
              } else {
              this.reemprimirRecibo(res[0])
              }
              this.planDePagos = []
              this.limpiar()
              this.isButtonDisabledPago = false
            })
           }
           else {
            if(this.bluetooth) {
              this.imprimirArchivoBlue(res[0])
            } else {
            this.reemprimirRecibo(res[0])
            }
            this.planDePagos = []
            this.limpiar()
            this.isButtonDisabledPago = false
          }
          this.planDePagos = []
          this.limpiar()
          this.isButtonDisabledPago = false
        },(error)=>{
          this.isButtonDisabledPago = false
          console.log(error)
        })
  })
}

async infoPlanDePagos(item:any) {
  let cuentasPorCobrarId = item.cuentasPorCobrarId
  let modal = this.modalControllers.create(CuentasPorCobrarCreditosVisualizarPlanDePagosPage,{data:cuentasPorCobrarId},
      {
       cssClass: 'fullscreen-modal',
       enableBackdropDismiss: true
     }
    )
    modal.present();
    modal.onDidDismiss(data => {
     if (data !== null && data !== undefined ) {
     }
    })
}

  selectInputContent(event: any) {
    const inputElement = event.target;
    if(inputElement && inputElement.value) {
      inputElement.setSelectionRange(0, inputElement.value.length);
    }
  }
  isString(value: any): boolean {
    return typeof value === 'string';
  }

  actualizarValorCuota(item:any) {
    item.totalPagoActual = item.valorCuota
    item.mostrarPlanDePagos = true
    // let totalSeleccionadoCopia = 0
    // let totalDeudaFecha = 0
    // this.datosCredito.forEach(valores => {
    //   if(valores.mostrarPlanDePagos) {
    //     totalSeleccionadoCopia += valores.totalPagoActual;
    //     totalDeudaFecha += valores.totalDeudaFecha
    //     }
    // });
    // let totalPagoActualGeneral = totalSeleccionadoCopia + item.totalPagoActual
    // if(totalDeudaFecha < totalPagoActualGeneral) {
    //   let totalDeudaFechaFormateado = totalDeudaFecha.toLocaleString('en-US');
    //   let totalPagoActualGeneralFormateado = totalSeleccionadoCopia.toLocaleString('en-US');
    //   let pagoActualIndividualFormateado = item.totalPagoActual.toLocaleString('en-US');

    //   this.utils.mensajeMuestro('Abono crédito',`El abono de : ${pagoActualIndividualFormateado} sumado
    //      con los pagos actuales ${totalPagoActualGeneralFormateado} supera el total de la deuda ${totalDeudaFechaFormateado} .`,'warning')
    // } else {
    //   this.totalSeleccionado += item.totalPagoActual;
    // }
    this.totalSeleccionado += item.totalPagoActual;
  }

 async calcularNumeroCuota(item, numericValue:any) {
    this.factura = item.cuentasPorCobrarId
    let companiasId = await this.storage.get('companiasId')
    const responseCalcularCreditos = await this.servicio.calcularValoresCuentaPorCobrarAsync(
      companiasId,item.cuentasPorCobrarId);
    const resultadoCalcularCreditos = responseCalcularCreditos.json();
    console.log(resultadoCalcularCreditos.data[0])

        // Obtener el valor de valorAcumuladoCuota donde numericValue == nroCuota
        const cuota = resultadoCalcularCreditos.data[0].find(c => c.nroCuota == numericValue);
        if (cuota) {
          const valorAcumuladoCuota = cuota.valorAcumuladoCuota;
          item.totalPagoActual = valorAcumuladoCuota
          item.mostrarPlanDePagos = true
          // this.totalSeleccionado += valorAcumuladoCuota
          this.actualizarTotalSeleccionado()
          console.log('Valor Acumulado Cuota:', valorAcumuladoCuota);
        } else {
          console.log('No se encontró la cuota correspondiente.');
        }
  }

onInputChange(values: string, value: any,item:any) {
  clearTimeout(this.timeoutId);
  this.timeoutId = setTimeout(() => {
    const numericValue = Number(value.replace(/,/g, '').replace(/\./g, ''));
    if (!isNaN(numericValue)) {
      this.calcularNumeroCuota(item, numericValue);
    } else {
      console.log('El valor ingresado no es un número válido.');
    }
  }, 2000);
}
}



// WEBPACK FOOTER //
// ./src/pages/cuentas-por-cobrar-creditos/cuentas-por-cobrar-creditos.ts